export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./Devedores.html?vue&type=template&id=5f777caa&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/devedores/Devedores.html?vue&type=template&id=5f777caa&
// module id = 478
// module chunks = 1